// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1yt__","label":"Completed_label__Cn84L"};